// Pages
import { Gabaritos } from './gabaritos.page'

export default Gabaritos
